export const useLastSlide = () => {
    return {

    }
}
